import { DIAL_OPTIONS } from "./dial-options";
import { CASE_OPTIONS } from "./case-options";
import { TWENTY_FOUR_OPTIONS } from "./twenty-four-hour-hand-options";
import { STRAP_OPTIONS } from "./strap-options";
import { BEZEL_OPTIONS } from "./bezel-options";
import { HANDS_OPTIONS } from "./hands-options";
import { SECONDS_OPTIONS } from "./seconds-options";
import { STAMP_OPTIONS } from "./stamp-options";
import { INITIAL_COLOR_OPTIONS } from "./initial-color-options";

export const CUSTOMISATION_OPTIONS = {
  case: {
    title: "Case",
    iconName: "Case",
    options: CASE_OPTIONS,
  },
  dial: {
    title: "Dial",
    iconName: "Dial",
    options: DIAL_OPTIONS,
  },
  strap: {
    title: "Strap",
    iconName: "Strap",
    options: STRAP_OPTIONS,
  },
  bezel: {
    title: "Bezel",
    iconName: "Bezel",
    options: BEZEL_OPTIONS,
  },
  hands: {
    title: "Hands",
    iconName: "Hands",
    options: HANDS_OPTIONS,
  },
  seconds: {
    title: "Seconds Hand",
    iconName: "SecondsHand",
    options: SECONDS_OPTIONS,
  },
  twentyFour: {
    title: "24h Hand",
    iconName: "TwoFourHourHand",
    options: TWENTY_FOUR_OPTIONS,
  },
  stamp: {
    title: "Stamp",
    iconName: "Stamp",
    options: STAMP_OPTIONS,
  },
  initials: {
    title: "Initials",
    iconName: "Initials",
    options: INITIAL_COLOR_OPTIONS,
  },
  engraving: {
    title: "Engraving",
    iconName: "Engraving",
    options: {},
  },
};
